import React, { useEffect } from "react";

// Importing Packages
import { v4 as uuidv4 } from "uuid";

//Importing Libraries
var Highcharts = require("highcharts");
// require('highcharts/highmaps')(Highcharts);
require("highcharts/modules/map")(Highcharts);
require("highcharts/modules/exporting")(Highcharts);

function SmallPie(props) {

  let id = generateRandomGuid();
  function generateRandomGuid() {
    return uuidv4();
  }

  useEffect(() => {
    function renderChart(id,colorset) {

      // Data retrieved from https://netmarketshare.com
      Highcharts.chart(`sp-${id}`, {
        chart: {
          margin: [0, 0, 0, 0],
          spacingTop: 0,
          spacingBottom: 0,
          spacingLeft: 0,
          spacingRight: 0,
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie",
          backgroundColor: null,
        },

        title: {
          text: "",
        },
        tooltip: {
          enabled: false,
          pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
        },

        credits: {
          enabled: false,
        },

        exporting: {
          enabled: false,
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            size: "100%",
            // height: '100%',
            borderWidth: 0,
            slicedOffset: 2.5,

            dataLabels: {
              enabled: false,
              format: "<b>{point.name}</b>: {point.percentage:.1f} %",
            },
          },
        },
        series: [
          {
            name: "Brands",
            colorByPoint: true,
            innerSize: "50%",
            data: [
              {
                name: "Other",
                y: 20.0,
                sliced: true,
                selected: true,
                color: colorset[0],
              },
              {
                name: "Chrome",
                y: 60.67,
                sliced: true,
                selected: true,
                color: colorset[1],
              },
            ],
          },
        ],
      });
    }

    renderChart(id, props.colorset);
  }, [id, props.colorset]);

  return <div id={`sp-${id}`}></div>;
}

export default SmallPie;
